import React from 'react';
import { TypedMemo } from '../../../common/types';
import { sourceLook } from '../streamingSources';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SourceMarkProps {
  integrationType: string;
}

/** The two-letter mark of a source (design §11: source mark). */
const SourceMarkComponent: React.FC<SourceMarkProps> = ({ integrationType }) => {
  const look = sourceLook(integrationType);
  return (
    <span className={styles.mark} title={look.name} aria-hidden>
      {look.code}
    </span>
  );
};

export const SourceMark = TypedMemo(SourceMarkComponent);
